module.exports = __webpack_public_path__ + "img/home.6f83213c.svg";